import React, { useState, useContext } from "react";
// import { AuthContext } from "../../contexts/AuthContext";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import { startEmailVerification } from "../../actions/auth";

export const EmailVerificacion = () => {
  // const { verificarCodigo } = useContext(AuthContext);
  const [codigo, setCodigo] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // Obtener el email desde el location.state (se debe pasar desde el registro)
  const email = location.state?.email;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!codigo.trim()) {
      Swal.fire("Error", "Ingrese el código de verificación", "error");
      return;
    }

    const result = await dispatch(startEmailVerification({ email, codigo }));

    if (result.ok) {
      Swal.fire("Éxito", "Código verificado correctamente", "success");
      navigate("/iniciar-sesion"); 
    } else {
      Swal.fire("Error", "Código inválido o expirado", "error");
    }
  };

  return (
    <div className="verificacion-container font-family-montserrat">
      <form className="verificacion-form" onSubmit={(e) => e.preventDefault()}>
        <h2 className="verificacion-title">Verifica tu código</h2>
        <p className="verificacion-instruccion">Ingresa el código que enviamos a tu correo electrónico.</p>

        <input
          id="codigo"
          type="text"
          placeholder="Código de verificación"
          value={codigo}
          onChange={(e) => setCodigo(e.target.value)}
          className="verificacion-input"
        />

        <div
          className="verificacion-boton"
          onClick={handleSubmit}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") handleSubmit();
          }}
        >
          Verificar 
        </div>
      </form>
    </div>
  );
}